import React, { useState, useEffect, useCallback, useRef } from 'react';
import { 
  ChevronDown, 
  Moon, 
  Sun, 
  Heart, 
  MapPin, 
  Calendar, 
  Lock, 
  Sparkles, 
  Star,
  ChevronLeft,
  ChevronRight,
  X
} from 'lucide-react';

// Milestone data - Replace with your actual data
const MILESTONES_DATA = [
  {
    id: 1,
    date: "March 19, 2025",
    title: "Where It All Began",
    description: "The moment I saw you, I knew my life would never be the same. Your smile lit up my heart.",
    image: "/images/milestone1.jpeg",
    location: "My friend's very nasty apartment 😵‍💫, Casablanca",
    phrase: "The best 10 seconds of your life",
    hiddenMessage: "You still give me butterflies (and headaches) every single day"
  },
  {
    id: 2,
    date: "March 29, 2025",
    title: "Our first 'I love you's",
    description: "You said you wanted to wait until we were face to face, but my love for you ran too deep, too restless to wait.",
    image: "/images/milestone2.jpeg",
    location: "Internet 🥲",
    phrase: "Let the record show, I said it first!",
    hiddenMessage: "And I'll always love you"
  },
  {
    id: 3,
    date: "May 9, 2025",
    title: "First 'real' date'",
    description: "It wasn’t the first time we sat across from each other, but somehow your smile still made my heart forget every moment before",
    image: "/images/milestone3.jpeg",
    location: "L'Abri Restaurant, Casablanca",
    hiddenMessage: "Fuck Othmane d'aujourd'hui and his ugly gf"
  },
  {
    id: 4,
    date: "May 10, 2025",
    title: "Meeting each other's friends",
    description: "You hated my best friend, and I kinda liked yours, so I guess the universe stayed balanced.",
    image: "/images/milestone4.jpeg",
    location: "EspressoLab, Casablanca",
    phrase: "I know it doesn't show but I swear I was happy",
    hiddenMessage: "I am speaking directly to Yahya now: when she shows you this, if you pull that 'oh he did this for other hoes' shit, I'll shoot you in the neck"
  },
  {
    id: 5,
    date: "May 10, 2025",
    title: "Abuse",
    description: "You’re the only one I’d let turn my face into your favorite skincare experiment.",
    image: "/images/milestone5.jpeg",
    location: "Your friend's house, Casablanca",
    hiddenMessage: "Okay I'll let you put a LIL BIT of make up on me next time"
  },
  {
    id: 6,
    date: "June 5, 2025",
    title: "Extraordinary love making",
    description: "Youth gives us the excuse, but love gives us the courage, to stay close, to laugh loud and to FUCK hard.",
    image: "/images/milestone6.jpeg",
    location: "That boujee but small Airbnb, Casablanca",
    hiddenMessage: "Some of the best sex we had, one particular session was so passionate we fought directly after 🥵"
  },
  {
    id: 7,
    date: "August 7, 2025",
    title: "Your First Visit",
    description: "With my favorite person at my favorite bar, I’ve never felt so effortlessly at ease.",
    image: "/images/milestone7.jpeg",
    location: "O'Groove bar, Grenoble",
    hiddenMessage: "To many more spots and dates"
  },
  {
    id: 8,
    date: "August 9, 2025",
    title: "Our First Trip",
    description: "Planning a revolution and creating traditions and memories that will warm our hearts forever.",
    image: "/images/milestone8.jpeg",
    location: "Jardin des Tuileries, Paris",
    phrase: "You're walking slow and you're doing on purpose for some reason 😡",
    hiddenMessage: "Sorry babe 😓"
  },
  {
    id: 9,
    date: "August 13, 2025",
    title: "Our First Swim",
    description: "Our first summer together, full of laughter, sunsets, and endless adventures",
    image: "/images/milestone9.jpeg",
    location: "Smy Vistamar Portocolom, Majorca",
    phrase: "Seeewyyyyy 🤪",
    hiddenMessage: "You're lucky there were other people at the pool"
  },
  {
    id: 10,
    date: "Your birthday",
    title: "Still Falling For You",
    description: "Celebrating the day my favorite person came into the world, grateful for every moment with you.",
    image: "/images/milestone10.jpeg",
    location: "Internet 😓",
    phrase: "I love you baby",
    hiddenMessage: "Happy 42nd birthday my MILF baby Shayla"
  }
];
// Configuration - Easy to modify
const CONFIG = {
  password: 'OumaimaIsVeryNonChalantTowardsHerPoorYasser',
  petName: 'My Shayla',
  specialDate: '2025-11-05',
  musicFile: '/music/willow.mp3'
};

// Login Screen Component
const LoginScreen = ({ password, setPassword, handleLogin, passwordError, isLoading }) => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 relative overflow-hidden">
    {/* Animated background */}
    <div className="absolute inset-0">
      {[...Array(5)].map((_, i) => (
        <div
          key={i}
          className="absolute animate-float opacity-10"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${i * 2}s`,
            fontSize: `${Math.random() * 40 + 60}px`
          }}
        >
          🤍
        </div>
      ))}
    </div>

    <form onSubmit={handleLogin} className="relative z-10 w-full max-w-md mx-4">
      <div className="bg-black/30 backdrop-blur-xl rounded-3xl p-8 border border-purple-500/20 shadow-2xl">
        <div className="text-center mb-8">
          <div className="inline-block p-4 bg-purple-600/20 rounded-full mb-4">
            <Lock className="w-12 h-12 text-purple-400" />
          </div>
          <h1 className="text-4xl font-serif text-white mb-2">Our Secret Garden</h1>
          <p className="text-purple-300">Enter the password to unlock our memories</p>
        </div>

        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter our special word..."
          className={`w-full px-4 py-3 bg-gray-900/50 border ${
            passwordError ? 'border-red-500 animate-shake' : 'border-purple-500/30'
          } rounded-xl text-white placeholder-gray-400 focus:outline-none focus:border-purple-500 transition-all`}
          disabled={isLoading}
        />

        {passwordError && (
          <p className="mt-2 text-red-400 text-sm text-center">
            That's not quite right, try again 💜
          </p>
        )}

        <button
          type="submit"
          disabled={isLoading || !password}
          className="w-full mt-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-xl transition-all transform hover:scale-105"
        >
          {isLoading ? 'Unlocking...' : 'Unlock Our Story'}
        </button>
      </div>
    </form>
  </div>
);


const App = () => {
  // State management
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [darkMode, setDarkMode] = useState(true);
  const [musicPlaying, setMusicPlaying] = useState(false);
  const [currentMilestone, setCurrentMilestone] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const [expandedImage, setExpandedImage] = useState(null);
  const [easterEggs, setEasterEggs] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  
  const audioRef = useRef(null);
  const milestonesRef = useRef([]);

  // Initialize audio
  useEffect(() => {
    audioRef.current = new Audio(CONFIG.musicFile);
    audioRef.current.loop = true;
    audioRef.current.volume = 0.3;
    
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  // Handle music toggle
  useEffect(() => {
    if (audioRef.current) {
      if (musicPlaying) {
        audioRef.current.play().catch(e => console.log('Audio play failed:', e));
      } else {
        audioRef.current.pause();
      }
    }
  }, [musicPlaying]);

  // Password validation
  const handleLogin = useCallback((e) => {
    e.preventDefault();
    setIsLoading(true);
    
    setTimeout(() => {
      if (password === CONFIG.password) {
        setIsAuthenticated(true);
        localStorage.setItem('loveTimelineAuth', 'true');
        setTimeout(() => setMusicPlaying(true), 1500);
      } else {
        setPasswordError(true);
        setTimeout(() => setPasswordError(false), 2000);
      }
      setIsLoading(false);
    }, 500);
  }, [password]);

  // Check for saved authentication
  useEffect(() => {
    const savedAuth = localStorage.getItem('loveTimelineAuth');
    if (savedAuth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  // Calculate days until special date
  const getDaysUntilSpecial = useCallback(() => {
    const specialDate = new Date(CONFIG.specialDate);
    const today = new Date();
    const diffTime = specialDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }, []);

  // Swipe handlers
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe && currentMilestone < MILESTONES_DATA.length - 1) {
      navigateToMilestone(currentMilestone + 1);
    }
    if (isRightSwipe && currentMilestone > 0) {
      navigateToMilestone(currentMilestone - 1);
    }
  };

  // Navigate to specific milestone
  const navigateToMilestone = (index) => {
    setCurrentMilestone(index);
    milestonesRef.current[index]?.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center' 
    });
  };

  // Shake detection for confetti
  useEffect(() => {
    if (!isAuthenticated) return;

    let lastX = 0, lastY = 0, lastZ = 0;
    const threshold = 15;
    let shakeTimeout = null;

    const handleMotion = (event) => {
      event.preventDefault(); // Prevent default iOS behaviors
      
      const current = event.accelerationIncludingGravity;
      if (!current) return;

      const deltaX = Math.abs(lastX - current.x);
      const deltaY = Math.abs(lastY - current.y);
      const deltaZ = Math.abs(lastZ - current.z);

      if ((deltaX > threshold && deltaY > threshold) || 
          (deltaX > threshold && deltaZ > threshold) || 
          (deltaY > threshold && deltaZ > threshold)) {
        
        // Debounce to prevent multiple triggers
        if (!shakeTimeout) {
          triggerConfetti();
          shakeTimeout = setTimeout(() => {
            shakeTimeout = null;
          }, 1000);
        }
      }

      lastX = current.x;
      lastY = current.y;
      lastZ = current.z;
    };

    // Request permission for iOS 13+
    const requestPermission = async () => {
      if (typeof DeviceMotionEvent !== 'undefined' && typeof DeviceMotionEvent.requestPermission === 'function') {
        try {
          const permission = await DeviceMotionEvent.requestPermission();
          if (permission === 'granted') {
            window.addEventListener('devicemotion', handleMotion, { passive: false, capture: true });
          }
        } catch (error) {
          console.log('Motion permission error:', error);
        }
      } else if (window.DeviceMotionEvent) {
        window.addEventListener('devicemotion', handleMotion, { passive: false, capture: true });
      }
    };

    requestPermission();

    return () => {
      window.removeEventListener('devicemotion', handleMotion);
      if (shakeTimeout) clearTimeout(shakeTimeout);
    };
  }, [isAuthenticated]);

  // Trigger confetti animation
  const triggerConfetti = () => {
    setShowConfetti(true);
    if (navigator.vibrate) navigator.vibrate(200);
    setTimeout(() => setShowConfetti(false), 3000);
  };

  // Toggle easter egg
  const toggleEasterEgg = (id) => {
    setEasterEggs(prev => ({ ...prev, [id]: !prev[id] }));
    if (navigator.vibrate) navigator.vibrate(50);
  };

  // Confetti Component
  const Confetti = () => (
    <div className="fixed inset-0 pointer-events-none z-50">
      {[...Array(50)].map((_, i) => (
        <div
          key={i}
          className="absolute animate-fall"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            fontSize: `${Math.random() * 20 + 10}px`
          }}
        >
          {['💜', '💕', '💖', '✨', '🤍'][Math.floor(Math.random() * 5)]}
        </div>
      ))}
    </div>
  );

  // Main Timeline View
  if (!isAuthenticated) {
    return <LoginScreen
      password={password}
      setPassword={setPassword}
      handleLogin={handleLogin}
      passwordError={passwordError}
      isLoading={isLoading}
    />;
  }

  return (
    <div 
      className={`min-h-screen transition-colors duration-500 ${
        darkMode 
          ? 'bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 text-white' 
          : 'bg-gradient-to-br from-purple-50 via-pink-50 to-purple-50 text-gray-900'
        }`
      }
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {showConfetti && <Confetti />}

      {/* Header */}
      <div className="sticky top-0 z-40 backdrop-blur-xl bg-black/20 border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <div>
              <h1 className={`text-3xl font-serif ${darkMode ? 'text-white' : 'text-gray-900'}`}>Our Love Story</h1>
              <p className="text-purple-300 text-sm">For {CONFIG.petName} 💜</p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setDarkMode(!darkMode)}
                className="p-2 bg-purple-600/20 hover:bg-purple-600/30 rounded-lg transition-colors"
              >
                {darkMode ? 
                  <Sun className="w-5 h-5 text-purple-300" /> : 
                  <Moon className="w-5 h-5 text-purple-300" />
                }
              </button>
            </div>
          </div>
          
          {/* Special date countdown */}
          <div className="mt-3 text-center">
            <p
              className={`text-xl inline-flex items-center justify-center gap-2 ${
                darkMode ? 'text-purple-300' : 'text-purple-700'
              } leading-relaxed`}
            >
              <Sparkles className="w-4 h-4" />
              {getDaysUntilSpecial() > 0 
                ? `${getDaysUntilSpecial()} days until we see each other` 
                : "Today is our special day! 🎉"
              }
              <Sparkles className="w-4 h-4" />
            </p>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="relative py-20 px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-5xl md:text-6xl font-serif text-white mb-6 animate-fadeIn">
            Dear {CONFIG.petName}
          </h2>
          <p className={`text-xl ${darkMode ? 'text-purple-300' : 'text-purple-700'} leading-relaxed`}>
            Every moment with you is a precious memory. This is our story, told through 
            the moments that made me fall in love with you more each day.
          </p>
          <ChevronDown className="w-8 h-8 text-purple-400 mx-auto mt-10 animate-bounce" />
        </div>
      </div>

      {/* Timeline Navigation */}
      {/* <div className="sticky top-20 z-30 bg-black/20 backdrop-blur-xl py-2 mb-8">
        <div className="flex items-center justify-center gap-4 px-4">
          <button
            onClick={() => navigateToMilestone(Math.max(0, currentMilestone - 1))}
            disabled={currentMilestone === 0}
            className="p-2 bg-purple-600/20 rounded-lg disabled:opacity-30 transition-all"
          >
            <ChevronLeft className="w-5 h-5 text-purple-300" />
          </button>
          <span className="text-purple-300 text-sm">
            Memory {currentMilestone + 1} of {MILESTONES_DATA.length}
          </span>
          <button
            onClick={() => navigateToMilestone(Math.min(MILESTONES_DATA.length - 1, currentMilestone + 1))}
            disabled={currentMilestone === MILESTONES_DATA.length - 1}
            className="p-2 bg-purple-600/20 rounded-lg disabled:opacity-30 transition-all"
          >
            <ChevronRight className="w-5 h-5 text-purple-300" />
          </button>
        </div>
      </div> */}

      {/* Timeline */}
      <div className="relative max-w-6xl mx-auto px-4 pb-20">
        {/* Center line */}
        {/* <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-gradient-to-b from-purple-600 to-pink-600 opacity-30" /> */}

        {MILESTONES_DATA.map((milestone, index) => (
          <div
            key={milestone.id}
            ref={el => milestonesRef.current[index] = el}
            className={`relative flex ${
              index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
            } flex-col items-center mb-16 animate-fadeIn`}
            style={{ animationDelay: `${index * 100}ms` }}
          >
            {/* Content Card */}
            <div className={`w-full md:w-5/12 ${
              index % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12 md:text-left'
            }`}>
              <div 
                className={`${darkMode ? 'bg-black/20' : 'bg-white/90'} backdrop-blur-xl rounded-2xl p-6 border ${
                  darkMode ? 'border-purple-500/20 hover:border-purple-500/40' : 'border-purple-300 hover:border-purple-400'
                } transition-all cursor-pointer hover:transform hover:scale-105`}
                onClick={() => toggleEasterEgg(milestone.id)}
              >
                <div className="flex items-center gap-2 mb-2 text-purple-400">
                  <Calendar className="w-4 h-4" />
                  <span className="text-sm">{milestone.date}</span>
                </div>
                
                <h3 className={`text-2xl font-serif ${darkMode ? 'text-white' : 'text-gray-900'} mb-3`}>
                  {milestone.title}
                </h3>
                
                <p className={`${darkMode ? 'text-gray-300' : 'text-gray-700'} mb-3`}>
                  {milestone.description}
                </p>

                {milestone.location && (
                  <div className="flex items-center gap-2 text-purple-300 text-sm mb-2">
                    <MapPin className="w-4 h-4" />
                    <span>{milestone.location}</span>
                  </div>
                )}

                {milestone.phrase && (
                  <p className="text-pink-300 italic text-sm mt-3">
                    "{milestone.phrase}"
                  </p>
                )}

                {easterEggs[milestone.id] && milestone.hiddenMessage && (
                  <div className="mt-4 p-3 bg-purple-600/20 rounded-lg border border-purple-500/30 animate-fadeIn">
                    <p className="text-purple-300 text-sm flex items-center gap-2">
                      <Heart className="w-4 h-4" fill="currentColor" />
                      {milestone.hiddenMessage}
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Center dot */}
            <div className="relative z-10 my-4 md:my-0">
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg animate-pulse">
                <Heart className="w-6 h-6 text-white" fill="currentColor" />
              </div>
            </div>

            {/* Image Card */}
            <div className={`w-full md:w-5/12 ${
              index % 2 === 0 ? 'md:pl-12' : 'md:pr-12'
            }`}>
              <div 
                className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-xl"
                onClick={(e) => {
                  e.stopPropagation();
                  setExpandedImage(milestone.image)}
                }
              >
                <img
                  src={milestone.image}
                  alt={milestone.title}
                  className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                  onError={(e) => {
                    e.target.src = `https://via.placeholder.com/800x600/4C1D95/FFFFFF?text=Memory+${index + 1}`;
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 text-white">
                    <p className="text-sm">Click to view full size</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* To Be Continued Section */}
      <div className="text-center py-20 px-4">
        <div className="inline-block bg-black/20 backdrop-blur-xl rounded-3xl p-10 border border-purple-500/20">
          <Star className="w-16 h-16 text-yellow-400 mx-auto mb-6" fill="currentColor" />
          <h2 className="text-4xl font-serif text-white mb-4">
            To Be Continued...
          </h2>
          <p className="text-purple-300 max-w-md mx-auto mb-6">
            Our story is still being written, with each day bringing new adventures, 
            deeper love, and countless reasons to be grateful for us.
          </p>
          <button
            onClick={triggerConfetti}
            className="px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-medium rounded-full transition-all transform hover:scale-105"
          >
            Celebrate Our Love 💜
          </button>
          
        </div>
      </div>

      {/* Image Modal */}
      {expandedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={(e) => {
            if(e.target === e.currentTarget){
              setExpandedImage(null)}
            }
          }
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-purple-300 transition-colors"
            onClick={(e) => {
              e.stopPropagation();
              setExpandedImage(null)
            }}
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={expandedImage}
            alt="Expanded view"
            className="max-w-full max-h-full object-contain rounded-lg"
          />
        </div>
      )}

      {/* CSS for animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        @keyframes fall {
          to { transform: translateY(100vh) rotate(360deg); }
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out forwards;
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .animate-fall {
          animation: fall 3s linear forwards;
        }
        .animate-shake {
          animation: shake 0.5s ease-in-out;
        }
        .animation-delay-200 {
          animation-delay: 200ms;
        }
        body {
          -webkit-user-select: none;
          user-select: none;
          -webkit-touch-callout: none;
        }
      `}</style>
    </div>
  );
};

export default App;